import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import axios from "axios";
import VueCookies from "vue-cookies";

window.$ = window.jQuery = require("jquery");

Vue.config.productionTip = false;

const $axios = axios.create({
  baseURL: process.env.VUE_APP_API_SERVER
});

Vue.prototype.$axios = $axios;
Vue.use(VueCookies);
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
